import { render, staticRenderFns } from "./addDemo.vue?vue&type=template&id=e1f2eea2&scoped=true"
import script from "./addDemo.vue?vue&type=script&lang=js"
export * from "./addDemo.vue?vue&type=script&lang=js"
import style0 from "./addDemo.vue?vue&type=style&index=0&id=e1f2eea2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f2eea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1f2eea2')) {
      api.createRecord('e1f2eea2', component.options)
    } else {
      api.reload('e1f2eea2', component.options)
    }
    module.hot.accept("./addDemo.vue?vue&type=template&id=e1f2eea2&scoped=true", function () {
      api.rerender('e1f2eea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/member/addDemo.vue"
export default component.exports